import angular, { IOnInit, IPromise } from "angular";

import { IQuery } from "../../server/query";
import {
  LookupManagementConfig,
  TypeSimilarItemInfo,
} from "../lookupManagement";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../server/serverUtility";

export class LookupEditModalController implements IOnInit {
  static $inject = [ServerUtilityName];
  Active: boolean = false;
  readonly defaultQuery: IQuery = {
    Disabled: undefined,
  };

  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: {
    similarItems: TypeSimilarItemInfo[];
    lookupManagementConfig: LookupManagementConfig;
    lookUpId: string;
  };

  constructor(private readonly serverUtility: ServerUtility) {
    this.setModalWidth("950px");
  }
  $onInit() {}
  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
  activeRecordChanged(Active: boolean) {
    this.Active = Active;
    if (Active) {
      this.defaultQuery.Disabled = false;
    } else {
      this.defaultQuery.Disabled = undefined;
    }
  }

  OnDeleteButtonClick(type: { name: string; id: string }) {
    this.serverUtility
      .sendApiRequest({
        method: "delete",
        url: `${this.resolve.lookupManagementConfig.baseUrl}/${this.resolve.lookUpId}?ReplacementId=${type.id}`,
      })
      .then((r) => {
        this.modalInstance.close(r);
      });
  }
}
